/***
 * this menu_link will impacts validate user access to page, if set here will use parents as link to verify, else will use
 * itself; if no met menu which set up in TMS will redirect to login page.
 * @type {{#/schedulePickup/Shipment: {parent: string}; #/schedulePickup/Review: {parent: string}; #/demo: {parent: string}; #/orderReview: {parent: string}; #/myAccount/edit: {parent: string}}}
 */
export const menu_link_obj: any = {
    '#/schedulePickup': {
        parent: '#/unis100Quote',
    },
    '#/schedulePickup/Shipment': {
        parent: '#/unis100Quote',
    },
    '#/schedulePickup/Review': {
        parent: '#/unis100Quote',
    },
    '#/demo': {
        parent: '',
    },
    '#/demo2': {
        parent: '',
    },
    '#/invoices': {
        parent: '',
    },
    '#/viewShipment': {
        parent: '',
    },
    '#/scheduleApickup': {
        parent: '',
    },
    '#/reviewPickupRequest': {
        parent: '',
    },
    '#/shipmentCconfirmation': {
        parent: '',
    },
    '#/billoflading': {
        parent: '',
    },
    '#/bol': {
        parent: '',
    },
    '#/orderReview': {
        parent: '',
    },
    '#/myAccount/edit': {
        parent: '#/myAccount',
    },
    '#/home': {
        parent: '',
    },
    '#/myCustomers': {
        parent: '#/myCustomers',
    },
    '#/getquote': {
        parent: '#/unis100Quote',
    },
    '#/savedQuote': {
        parent: '#/savedQuote',
    },
    '#/customerSignup': {
        parent: '#/customerSignup',
    },
    '#/Track': {
        parent: '#/Track',
    },
    '#/myAccount': {
        parent: '#/myAccount',
    },
    '#/addressBook': {
        parent: '#/addressBook',
    },
    '#/blank': {
        parent: '',
    },
    '#/newAddressBook': {
        parent: '#/newAddressBook',
    },
    '#/quote': {
        parent: '',
    },
    '#/estimatedQuote': {
        parent: '',
    },
    '#/shipment': {
        parent: '',
    },
    '#/trackShipmentLoggedIn': {
        parent: '',
    },
    '#/trackShipmentGuest': {
        parent: '',
    },
    '#/verifyEmail': {
        parent: '',
    },
    '#/userProfile': {
        parent: '',
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/router/state.ts